/**
 * @module printArticle
 */

/**
 * Print Article
 */

module.exports = function() {
    const printBtn = document.querySelector( '#export-as-pdf' );

    initPrintOnLoad();
    initPrintOnClick();

    function initPrintOnLoad() {
        const url = new URL( window.location );
        const params = new URLSearchParams( url.search );

        if ( params.has( 'print' ) ) {
            doPrint();

            // Remove ?print from URL without reloading
            params.delete( 'print' );
            url.search = params.toString();
            window.history.replaceState( {}, '', url );
        }
    }

    function initPrintOnClick() {
        printBtn.addEventListener( 'click', function( e ) {
            e.preventDefault();

            doPrint();
        } );
    }

    function doPrint() {
        printBtn.disabled = 'disabled';
        printBtn.classList.add( 'loading' );

        // Hide feedback block
        const hkbFeedbackParent = document.querySelector( '.hkb-feedback' ).parentElement;
        hkbFeedbackParent.classList.add( 'print-hidden' );

        // Find all article images
        const lazyImages = document.querySelectorAll( '.hkb-entry-content img' ); // lite speed cache

        // Loop found images
        if ( lazyImages.length > 0 ) {
            let loadedCount = 0;

            lazyImages.forEach( ( img ) => {
                // Check if image is lazy loaded
                const actualSrc = img.getAttribute( 'data-src' );
                if ( actualSrc ) {
                    img.src = actualSrc;
                    img.loading = 'eager';
                    img.srcset = '';
                }

                // Listen for the load event
                if ( img.complete && img.naturalHeight !== 0 ) {
                    loadedCount++;
                } else {
                    img.addEventListener( 'load', () => {
                        loadedCount++;
                        checkAllImagesLoaded();
                    } );

                    img.addEventListener( 'error', () => {
                        loadedCount++;
                        checkAllImagesLoaded();
                    } );
                }
            } );

            // Initial check in case all images were already cached/loaded
            checkAllImagesLoaded();

            function checkAllImagesLoaded() {
                if ( loadedCount === lazyImages.length ) {
                    delayAndPrint();
                }
            }
        } else {
            // Print if no images in the article
            delayAndPrint();
        }
    }

    function delayAndPrint() {
        setTimeout( function() {
            printBtn.disabled = '';
            printBtn.classList.remove( 'loading' );
            window.print();
        }, 500 );
    }
};
